import ScheduledReports from "./ScheduledReports";
export default ScheduledReports;